<template>
  <label class="products-filter-field products-filter-perpage">
    <span><b-icon icon="list-ol"></b-icon> در صفحه</span>
    <input
      class="products-filter-input"
      dir="ltr"
      type="number"
      min="1"
      @keypress.enter.prevent="changePerPage"
      @change="changePerPage"
      v-model="per_page"
    >
  </label>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      per_page: 12,
    }
  },
  methods: {
    changePerPage() {
      if (this.per_page > 0) {
        let page = 1
        this.$store.commit('Product/setFilters', {key: 'per_page', value: this.per_page})
        this.$emit('updateFilter', {per_page: this.per_page})
        this.$store.dispatch("Product/setDashboardProducts", page);
      }
    }
  },
  mounted() {
    const value = this.$route.query.per_page;
    if (value != undefined) {
      this.per_page = value
      this.$store.commit('Product/setFilters', {key: 'per_page', value: value})
    }
  },
  destroyed() {
    this.$store.commit('Product/setFilters', {key: 'per_page', value: 12})
  }
}
</script>
